import {createSelector} from 'reselect';

import {ConnectionStatus, UpdateSWStatusType} from '@/constants/dataEnum';

import {getUpdateSWStatus} from './updateSystemSelector';

export const getSignalRState = (state) => state.signalRState;

export const getConnState = createSelector([getSignalRState], (signalRState) => signalRState.deviceHubConnectionState);

export const getIsAutoRefreshUpdateSW = createSelector(
  [getConnState, getUpdateSWStatus],
  (connState, updateSWStatus) =>
    [ConnectionStatus.RECONNECTING, ConnectionStatus.ERROR, ConnectionStatus.CLOSE].includes(connState) &&
    updateSWStatus === UpdateSWStatusType.COMPLETE,
);
